import { render, staticRenderFns } from "./recruit_benefit.vue?vue&type=template&id=5ff1a6f1&scoped=true"
import script from "./recruit_benefit.vue?vue&type=script&lang=js"
export * from "./recruit_benefit.vue?vue&type=script&lang=js"
import style0 from "./recruit_benefit.vue?vue&type=style&index=0&id=5ff1a6f1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1a6f1",
  null
  
)

export default component.exports